import LogoMark from "./LogoMark";

export default function Header() {
  return (
    <nav className="nav" aria-label="Main navigation">
      <a href="#top" className="brand" aria-label="Gospel Piano Coaching home">
        <span className="brand-mark">
          <LogoMark />
        </span>
        <span>Gospel Keys Made Simple</span>
      </a>
    </nav>
  );
}
